import styled from 'styled-components'

const EventHeroItemStyle = styled.section`
	--rightContentMaxWidth: var(--sp121x);
	--eventHeroTextMTop: var(--sp2x);
	--eventHeroBannerMTop: var(--sp13x);
	--iconInfoDistance: var(--sp3x);
	--eventBannerPad: var(--sp4x);
	--partWidth: 50%;
	--eventHeroImageHeight: 135%;

	.event-hero-section {
		* {
			cursor: none;
		}

		.event-hero-image {
			.image-cont {
				overflow: hidden;
				isolation: isolate;
				border-radius: var(--borderRadiusSize);
				padding-top: var(--eventHeroImageHeight);

				img {
					border-radius: var(--borderRadiusSize);
				}
			}
		}

		.event-hero-info {
			display: flex;
			justify-content: flex-end;

			.event-internal {
				display: flex;
				align-items: center;
				width: var(--rightContentMaxWidth);

				.event-content {
					width: 100%;

					.event-hero-text {
						margin-top: var(--eventHeroTextMTop);
					}

					.event-banner {
						display: flex;
						flex-wrap: wrap;
						border-top: 1px solid var(--primaryColor9);
						border-bottom: 1px solid var(--primaryColor9);
						margin-top: var(--eventHeroBannerMTop);

						.left-part {
							width: var(--partWidth);
							display: flex;
							border-right: 1px solid var(--primaryColor9);
							padding: var(--eventBannerPad);
							padding-left: 0;

							i {
								margin-right: var(--iconInfoDistance);

								&:before {
									color: var(--primaryColor9);
								}
							}
						}

						.right-part {
							width: var(--partWidth);
							display: flex;
							padding: var(--eventBannerPad);
							padding-right: 0;

							i {
								margin-right: var(--iconInfoDistance);

								&:before {
									color: var(--primaryColor9);
								}
							}
						}
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
		--rightContentMaxWidth: var(--sp91x);
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp10x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp3x);
		--partWidth: 50%;
		--eventHeroImageHeight: 134.8%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
		--rightContentMaxWidth: var(--sp71x);
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp8x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp3x);
		--partWidth: 50%;
		--eventHeroImageHeight: 135.5%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
		--rightContentMaxWidth: var(--sp70x);
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp8x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp3x);
		--partWidth: 50%;
		--eventHeroImageHeight: 134.7%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
		--rightContentMaxWidth: var(--sp62x);
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp6x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp3x);
		--partWidth: 50%;
		--eventHeroImageHeight: 134.9%;
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
		--rightContentMaxWidth: var(--sp60x);
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp6x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp3x);
		--partWidth: 50%;
		--eventHeroImageHeight: 134.8%;

		.event-hero-image {
			width: 43.34% !important;
			padding-right: 0 !important;
		}

		.event-hero-info {
			width: calc(100% - 43.34%) !important;
			padding-left: 0 !important;
		}

		.event-banner {
			width: 100% !important;
			align-items: center;

			.banner-left-part-tablet-version,
			.banner-right-part-tablet-version {
				width: 50%;
			}

			.banner-left-part-tablet-version {
				padding: var(--sp2x) 0;
				border-right: 1px solid var(--primaryColor9);

				.first-col,
				.last-col {
					display: flex;

					i {
						margin-right: var(--iconInfoDistance);

						&:before {
							color: var(--primaryColor9);
						}
					}
				}

				.first-col {
					padding-bottom: var(--sp2x);
					border-bottom: 1px solid var(--primaryColor9);

					.date-time {
						padding-right: var(--sp2x);
					}
				}

				.last-col {
					padding-top: var(--sp2x);

					.comp-title {
						padding-right: var(--sp2x);
					}
				}
			}

			.banner-right-part-tablet-version {
				padding: var(--sp2x) 0;
				padding-left: var(--sp7x);

				.banner-internal-wrap {
					.event-drag-tablet {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 100%;
						max-width: var(--roundButtonCursorSize);
						height: var(--roundButtonCursorSize);
						border-radius: 50%;
						color: var(--bodyColor);
						background-color: var(--primaryColor9);
						transform: rotate(-40deg);
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
		--rightContentMaxWidth: 100%;
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp4x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp3x);
		--partWidth: 50%;
		--eventHeroImageHeight: 88.3%;

		.event-hero-image {
			display: flex;
			justify-content: center;

			.image-cont {
				width: 57.3vw;
			}
		}

		.event-hero-info {
			margin-top: var(--sp6x);
		}

		.event-banner {
			width: 100% !important;
			align-items: center;

			.banner-left-part-tablet-version,
			.banner-right-part-tablet-version {
				width: 50%;
			}

			.banner-left-part-tablet-version {
				padding: var(--sp2x) 0;
				border-right: 1px solid var(--primaryColor9);

				.first-col,
				.last-col {
					padding-left: var(--sp2x);
					display: flex;

					i {
						margin-right: var(--iconInfoDistance);

						&:before {
							color: var(--primaryColor9);
						}
					}
				}

				.first-col {
					padding-bottom: var(--sp2x);
					border-bottom: 1px solid var(--primaryColor9);

					.date-time {
						padding-right: var(--sp10x);
					}
				}

				.last-col {
					padding-top: var(--sp2x);

					.comp-title {
						padding-right: var(--sp10x);
					}
				}
			}

			.banner-right-part-tablet-version {
				padding: var(--sp2x) 0;
				padding-left: var(--sp15x);

				.banner-internal-wrap {
					.event-drag-tablet {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 100%;
						max-width: var(--roundButtonCursorSize);
						height: var(--roundButtonCursorSize);
						border-radius: 50%;
						color: var(--bodyColor);
						background-color: var(--primaryColor9);
						transform: rotate(-40deg);
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		--rightContentMaxWidth: 100%;
		--eventHeroTextMTop: var(--sp2x);
		--eventHeroBannerMTop: var(--sp3x);
		--iconInfoDistance: var(--sp2x);
		--eventBannerPad: var(--sp2x);
		--partWidth: 100%;
		--eventHeroImageHeight: 133.7%;

		.event-hero-info {
			margin-top: var(--sp4x);
		}

		.event-banner {
			.banner-left-part-mobile-version {
				width: 100%;
				display: flex;
				align-items: center;

				.first-col,
				.last-col {
					width: 50%;
					display: flex;

					i {
						margin-right: var(--iconInfoDistance);

						&:before {
							color: var(--primaryColor9);
						}
					}
				}

				.first-col {
					border-right: 1px solid var(--primaryColor9);
					padding: var(--sp2x);
					height: 100%;
					padding-left: 0;
					align-items: center;

					.first-col-internal {
						display: flex;
					}
				}

				.last-col {
					padding: var(--sp2x);
					padding-left: var(--sp6x);
					padding-right: 0;

					.banner-internal-wrap {
						.event-drag-mobile {
							display: flex;
							align-items: center;
							justify-content: center;
							width: 100%;
							max-width: var(--roundButtonCursorSize);
							height: var(--roundButtonCursorSize);
							border-radius: 50%;
							color: var(--bodyColor);
							background-color: var(--primaryColor9);
							padding: var(--sp2-5x) var(--sp1x);
							text-align: center;
						}
					}
				}
			}

			.banner-right-part-mobile-version {
				width: 100%;
				display: flex;
				border-top: 1px solid var(--primaryColor9);
				padding: var(--sp2x) 0;
				padding-right: var(--sp2x);

				i {
					margin-right: var(--iconInfoDistance);

					&:before {
						color: var(--primaryColor9);
					}
				}
			}
		}
	}
`

export default EventHeroItemStyle
